<template>
  <div>
    <a-card class="customer-filter" size="small">
      <a-page-header title="权限管理">
        <a-form-model :form="filterForm" :label-col="{ span: 6 }" :model="filterForm" class="search-form">
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-model-item label="名称">
                <a-input v-model="filterForm.name" placeholder="权限名称" class="form-model-item" @change="onSearch" />
              </a-form-model-item>
            </a-col>
            <a-col :span="6">
              <a-form-model-item label="类型">
                <a-select v-model="filterForm.permission_type" style="width: 100%" class="form-model-item" placeholder="权限类型" @change="onSearch">
                  <a-select-option v-for="(item, key) in permissionTypes" :key="key" :value="item.value"> {{ item.label }} </a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="6">
              <a-form-model-item label="Code">
                <a-input v-model="filterForm.code" placeholder="Code" class="form-model-item" @change="onSearch" />
              </a-form-model-item>
            </a-col>
            <a-col :span="6" style="float: right; text-align: right">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button :style="{ margin: '0 8px' }" @click="onReset">重置</a-button>
            </a-col>
          </a-row>
        </a-form-model>
      </a-page-header>
    </a-card>
    <a-card title="权限列表" size="small">
      <span slot="extra">
        <a-button v-has="{ code: 'system:permission:add', project: 0 }" class="handle-menu" type="primary" icon="plus" @click="onAdd">添加</a-button>
      </span>
      <a-table v-if="permissionData" :scroll="{ y: 570 }" :pagination="false" :columns="columns" :data-source="permissionData" row-key="id" :expanded-row-keys.sync="expandedRowKeys" :default-expand-all-rows="true">
        <span slot="action" slot-scope="text, record">
          <a v-dis="{ code: 'system:permission:edit', project: 0 }" @click="onEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a v-dis="{ code: 'system:permission:delete', project: 0 }" @click="onDelete(record)">删除</a>
        </span>
        <span slot="icon" slot-scope="text, record">
          <a-icon v-if="record.icon" :type="record.icon" />
          <span v-else>--</span>
        </span>
        <span slot="hide" slot-scope="text, record">
          <span v-if="record.hide === null">--</span>
          <span v-else> {{ record.hide !== 0 ? '是' : '否' }} </span>
        </span>
        <span slot="route" slot-scope="text, record">
          {{ record.route || '--' }}
        </span>
        <span slot="permissionType" slot-scope="text, record">
          <a-tag :color="permissionTypes[record.permission_type].color"> {{ permissionTypes[record.permission_type].label }} </a-tag>
        </span>
      </a-table>
    </a-card>
    <permission-drawer :is-show="visible" :permission-id="currentId" :permission-data="currentData" @close="close" />
  </div>
</template>

<script>
import { permissionTypes } from '@/utils/dictionary';
import { permissionList, permissionDelete } from '@/api/system/auth';
import PermissionDrawer from '@/pages/system/permissions/components/PermissionDrawer';

const columns = [
  {
    title: '名称',
    dataIndex: 'name',
    key: 'name',
    width: '20%',
    ellipsis: true
  },
  {
    title: '图标',
    dataIndex: 'icon',
    key: 'icon',
    align: 'center',
    width: 80,
    scopedSlots: { customRender: 'icon' }
  },
  {
    title: '类型',
    dataIndex: 'permission_type',
    key: 'permission_type',
    align: 'center',
    width: 80,
    scopedSlots: { customRender: 'permissionType' }
  },
  {
    title: '权限标识',
    dataIndex: 'code',
    key: 'code',
    ellipsis: true
  },
  {
    title: '路径',
    dataIndex: 'route',
    key: 'route',
    ellipsis: true,
    scopedSlots: { customRender: 'route' }
  },
  {
    title: '是否隐藏',
    dataIndex: 'hide',
    key: 'hide',
    align: 'center',
    width: 100,
    scopedSlots: { customRender: 'hide' }
  },
  {
    title: '创建时间',
    dataIndex: 'created_time',
    key: 'created_time',
    align: 'center',
    width: 180
  },
  {
    title: '操作',
    align: 'center',
    width: 110,
    scopedSlots: { customRender: 'action' }
  }
];

export default {
  components: { PermissionDrawer },
  data() {
    return {
      columns,
      expandedRowKeys: [],
      permissionTypes,
      loading: false,
      filterForm: {
        name: null,
        code: null,
        permission_type: null
      },
      permissionData: null,
      visible: false,
      currentId: null,
      currentData: {}
    };
  },
  created() {
    this.getPermissionList();
  },
  methods: {
    onReset() {
      this.filterForm = {
        name: null,
        code: null,
        permission_type: null
      };
      this.getPermissionList();
    },

    onSearch() {
      this.getPermissionList();
    },

    getPermissionList() {
      permissionList(this.filterForm)
        .then(res => {
          this.permissionData = res.data.items;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    onAdd() {
      this.visible = true;
    },

    onEdit(record) {
      this.visible = true;
      this.currentId = record.id;
      this.currentData = record;
    },

    onDelete(record) {
      const self = this;
      this.$confirm({
        title: '确认',
        content: '确认要删除该权限吗？',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          permissionDelete({ id: record.id }).then(() => {
            self.$message.success('删除成功');
            self.getPermissionList();
          });
        }
      });
    },

    close(type = 'submit') {
      this.visible = false;
      this.currentId = null;
      this.currentData = {};
      if (type === 'submit') {
        this.getPermissionList();
      }
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .customer-filter {
  .ant-page-header {
    padding: 0;
  }
  margin-bottom: 16px;
  .ant-form-item {
    margin-bottom: 8px;
    display: flex;
    .ant-form-item-control-wrapper {
      flex: 1;
    }
  }
  .filter-right {
    float: right;
    text-align: right;
  }
}
</style>
